<template>
  <div class="ChartsOpicityConfiger">
    <div class="p-line"></div>
    <div class="p-name">透明度</div>
    <div class="p-body">
      <el-slider @change="handleChange" :step="0.05" :max="1" v-model="opacity"></el-slider>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ChartsOpicityConfiger',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      opacity: 1,
    };
  },
  created() {
    this.opacity = this.propertyData[this.propertyDataKey].value;
  },
  mounted() {
    /* 获取初始值 */
  },
  methods: {
    handleChange(val) {
      /* 更新数据 */
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: parseFloat(val),
      });
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.ChartsOpicityConfiger {
  width: 100%;
  box-sizing: border-box;
  margin-top: 20px;
  .p-line {
    width: 100%;
    height: 1px;
    background-image: linear-gradient(
      to left,
      rgba(204, 204, 204, 0),
      rgb(143, 143, 143),
      rgba(204, 204, 204, 0)
    );
    margin-bottom: 5px;
  }
  .p-name {
    color: $property-title-color;
    font-size: $property-title-size;
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    height: 30px;
    line-height: 30px;
  }
  .p-body {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
  }
}
</style>
